/**
 * @fileoverview Número da OS antes do nome do contato ("BR827372 Jonas
 * Camargo"): a triagem pode pôr o número no nome para a equipe achar a
 * conversa pela OS, mas o cliente não pode recebê-lo como se fosse o nome
 * dele. Mesma regra do backend (helpers/workOrderNamePrefix.ts): sai o
 * primeiro pedaço com 5 dígitos ou mais, se sobrar um nome com letra.
 */

const PREFIX = /^([A-Za-z0-9][A-Za-z0-9./-]*\d)(?:\s*[-–—·|:]\s*|\s+)(?=\S)/;
const MIN_DIGITS = 5;

const digitCount = (s) => (s.match(/\d/g) || []).length;
const hasLetter = (s) => /\p{L}/u.test(s);

/** O nome sem o número da OS na frente; sem número, o nome como veio. */
export const stripWorkOrderPrefix = (name) => {
  const original = name ?? "";
  let rest = String(original).replace(/\s+/g, " ").trim();
  let stripped = false;
  // Em laço: "BR111111 BR222222 Jonas" (o número de duas OS) vira "Jonas".
  for (;;) {
    const m = PREFIX.exec(rest);
    if (!m || digitCount(m[1]) < MIN_DIGITS) break;
    const remaining = rest.slice(m[0].length).trim();
    if (!hasLetter(remaining)) break;
    rest = remaining;
    stripped = true;
  }
  return stripped ? rest : String(original);
};
